class ResponsiveMedia extends HTMLElement {
  constructor() {
    super();
    this.handlers = {};
  }

  connectedCallback() {
    const image = [...this.querySelectorAll('img')].find((el) => getComputedStyle(el).display !== 'none');
    this.image = image;

    if (image && !image.complete) {
      this.handlers.load = () => image.toggleAttribute('data-loading', false);
      image.addEventListener('load', this.handlers.load);
      image.toggleAttribute('data-loading', true);
    }

    const videos = [...this.querySelectorAll('video')];
    const hasVideo = videos.length > 0;

    if (hasVideo) {
      const video = [...this.querySelectorAll('video')].find((el) => getComputedStyle(el).display !== 'none');
      this.video = video;

      visible(this, { rootMargin: '450px' }).then(() => {
        if (video && video.hasAttribute('data-loading')) {
          video.addEventListener('loadeddata', () => {
            video.toggleAttribute('data-loading', false);
          });
          video.play();
        }
      });

      this.handlers.resize = () => {
        const currentVideo = [...this.querySelectorAll('video')].find((el) => getComputedStyle(el).display !== 'none');
        if (currentVideo && currentVideo !== video && currentVideo.hasAttribute('data-loading')) {
          currentVideo.addEventListener('loadeddata', () => {
            currentVideo.toggleAttribute('data-loading', false);
          });
          currentVideo.play();
        }
      };

      window.addEventListener('resize', this.handlers.resize);
    }

    visible(this).then(() => {
      this.toggleAttribute('data-visible', true);
    });
  }

  disconnectedCallback() {
    if (this.handlers.resize) {
      window.removeEventListener('resize', this.handlers.resize);
    }

    if (this.image && this.handlers.load) {
      this.image.removeEventListener('load', this.handlers.load);
    }

    this.image = null;
    this.video = null;
    this.handlers.resize = null;
    this.handlers.load = null;
  }

}
customElements.define('responsive-media', ResponsiveMedia);
